<template>
    <div
        :class="[
            `bg-${modelClass} border-${modelClass}-accent text-${modelClass}-accent text-sm`,
            'w-fit border border-current flex-shrink-0 rounded-tag px-[6px] font-medium font-sans leading-[14px] tracking-[0.2px] h-[20px] inline-flex items-center',
        ]"
    >
        <p v-text="$lang.get('Featured')" />
    </div>
</template>

<script>
export default {
    name: 'FeaturedTag',

    props: {
        modelClass: {
            type: String,
            required: true,
        },
    },
}
</script>
